import clsx from 'clsx'
import { IconNames } from 'lib/settings/icons'
import { HTMLProps } from 'react'

export interface IconProps extends HTMLProps<HTMLSpanElement> {
  /**
   * Optional icon name to use
   */
  icon?: IconNames
  /**
   * Optional URL to use as the icon
   */
  iconUrl?: string
  /**
   * Optional additional classes to apply to the icon
   */
  className?: string
}

export default function Icon({
  icon,
  iconUrl,
  className = '',
  ...props
}: IconProps) {
  return (
    <span
      className={clsx(
        `${icon ? 'icon-' + icon + ' ' : ''}flex-shrink-0`,
        iconUrl && 'bg-no-repeat bg-center bg-contain',
        className,
      )}
      style={{
        backgroundImage: iconUrl && `url(${iconUrl})`,
      }}
      aria-hidden={true}
      {...props}
    ></span>
  )
}
